/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { ProjetoComponentesEdicao, SITUACAO_COMPONENTE } from "./type";
import { Icon, IconButton, TableCell, TableRow } from "@mui/material";
import { orange, red } from "@mui/material/colors";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faLevelUpAlt, faPlus } from "@fortawesome/free-solid-svg-icons";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { notifierStore } from "src/framework/store/NotifierStore";
import { InputInteger } from "src/framework/components/forms/inputs/InputInteger";
import { InputDecimal } from "src/framework/components/forms/inputs/InputDecimal";

interface IRowComponente {
    componente: ProjetoComponentesEdicao
    substitutos?: ProjetoComponentesEdicao[];
    indexRow: number;
    onChange: (componente: ProjetoComponentesEdicao, index: number, substituto?: boolean) => void;
    callAddComponente: (componente: any) => void;
    onDelete: (index: number) => void;
    onReactive?: (componenteId: number) => void;
    onRecalc: (componenteId: number) => void;
}

const RowComponente: FC<IRowComponente> = ({ componente, substitutos = [], indexRow, onChange, onDelete, callAddComponente, onReactive, onRecalc}) => {
    const [valorTotal, setValorTotal] = useState<number>(0);

    const componenteData = useCallback(() => componente, [componente])

    const disabled = useCallback(() => {
        return SITUACAO_COMPONENTE.EXCLUIDO === componente.situacao as any ||  SITUACAO_COMPONENTE.SUBSTITUIDO === componente.situacao as any
    }, [componenteData().situacao])

    const renderSituacao = (situacao: SITUACAO_COMPONENTE): React.ReactNode => {
        switch (situacao) {
            case SITUACAO_COMPONENTE.ALTERADO:
                return <span style={{ color: orange[500] }}>Alterado</span>
            case SITUACAO_COMPONENTE.EXCLUIDO:
                return <span style={{ color: red[500] }}>Excluído</span>
            case SITUACAO_COMPONENTE.NOVO:
                return <span style={{ color: "#00a335" }}>Novo</span>
            case SITUACAO_COMPONENTE.ORIGINAL:
                return <span>Original</span>
            case SITUACAO_COMPONENTE.SUBSTITUIDO:
                return <span style={{ color: orange[500] }}>Substituido</span>
            default:
                return ""
        }
    }

    const handleReactive = () => {
        confirmationDialog.setup({
            title: "Aviso!",
            content: "Deseja desfazer a exclusão deste componente?",
            onClose: () => {
                confirmationDialog.close();
            },
            onConfirmation: () => {
                if (onReactive) {
                    onReactive(parseInt(`${componenteData().componente_id}`))
                    confirmationDialog.close();
                }
            }
        })
        confirmationDialog.open()
    }

    useEffect(() => {
        setValorTotal(componente.valor || 0)
    }, []);
    /*
    useEffect(() => {
        if(componente.valor && componente.quantidade){
            const valorUnitario = DecimalUtil.toFixed(componente.valor / componente.quantidade, 2);
            setValorTotal(DecimalUtil.toFixed(valorUnitario * componente.quantidade, 2) || 0)
        }
    }, [valorTotal]);
    */
    useEffect(() => {
        const valor = (
            !componente?.valor && 
            !componente?.quantidade_original && 
            componente?.quantidade && 
            componente?.valor_unitario
        ) ? componente?.valor_unitario : componente.valor;

        setValorTotal(valor || 0)
    }, [componente.quantidade]);

    const haveError = useMemo(()=>{
        if (componente.situacao === SITUACAO_COMPONENTE.EXCLUIDO) return false
        if (componente.situacao === SITUACAO_COMPONENTE.SUBSTITUIDO) return false
        if (Number(valorTotal || 0) > 0) return false
        return true
    },[componente, valorTotal])

    return (
        <>
            <TableRow >
                <TableCell style={{ width: 112 }}>
                    {renderSituacao(componenteData().situacao as SITUACAO_COMPONENTE)}
                </TableCell>
                <TableCell align="right">
                    {componenteData()?.componente_id}
                </TableCell>
                <TableCell>
                    {componenteData()?.modelo}
                </TableCell>
                <TableCell align="right">
                    {componenteData()?.quantidade_original}
                </TableCell>
                <TableCell style={{ width: 130 }}>
                    <InputInteger
                        name={`quantidade1-${componenteData().componente_id}`}
                        margin="none"
                        value={componenteData()?.quantidade?.toString()}
                        label={null}
                        type={"number"}
                        disabled={disabled()}
                        maxLength={6}
                        onChangeValue={(name: string, value: any) => {
                            const _componente = { ...componente };
                            const qtd = parseInt(value);
                            _componente.quantidade = qtd;
                            onChange(_componente, indexRow);

                        }}
                        onBlur={() => {
                            const componenteId: number = parseInt(`${componente.componente_id}`);
                            onRecalc(componenteId);
                        }}
                    />
                </TableCell>
                <TableCell style={{ width: 200 }} align={Formater.toAlign(TypeRecords.CURRENCY)} >
                    {Formater.toString(componente?.valor_unitario || 0, TypeRecords.CURRENCY)}
                </TableCell>
                <TableCell style={{ width: 200 }}>
                    <InputDecimal
                        prefix={<><span>R$&nbsp;</span></>}
                        value={parseFloat(`${valorTotal}`)}
                        defaultValue={componente.valor}
                        disabled={disabled()}
                        decimal={2}
                        maxLength={11}
                        label={null}
                        error={haveError}
                        onChange={(event: any) => {
                            const _componente = { ...componente };
                            const valor = parseFloat(event.target.value.toString().replace(/,/, "."));
                            _componente.valor = valor
                            setValorTotal(valor)
                            onChange(_componente, indexRow)

                        }}
                        onBlur={() => {
                            const componenteId: number = parseInt(`${componente.componente_id}`);
                            if(componente.valor && componente.quantidade){
                                const valorUnitario = DecimalUtil.toFixed(componente.valor / componente.quantidade, 5);
                                setValorTotal(DecimalUtil.toFixed(valorUnitario * componente.quantidade, 2) || 0)
                            }
                            onRecalc(componenteId);
                        }}
                    />
                </TableCell>
                <TableCell style={{ width: 66 }}>
                    {componente.situacao === SITUACAO_COMPONENTE.NOVO ? "" : componente.situacao !== SITUACAO_COMPONENTE.SUBSTITUIDO ? (
                        <IconButton
                        size={"small"}
                        disabled={disabled()}
                        onClick={() => {
                            callAddComponente(componente);
                        }}>
                        <FontAwesomeIcon icon={faEdit} />
                    </IconButton>

                    ) : (
                        <IconButton
                            size={"small"}
                            onClick={() => {
                                callAddComponente(componente)
                            }}>
                            <FontAwesomeIcon icon={faPlus} color={orange[500]} />
                        </IconButton>
                    )}
                </TableCell>
                <TableCell style={{ width: 20 }}>
                    {/* {componente.situacao !== SITUACAO_COMPONENTE.EXCLUIDO ? } */}
                    {componente.situacao !== SITUACAO_COMPONENTE.EXCLUIDO ? 
                    (
                        <IconButton
                        size={"small"}
                        onClick={() => {
                            onDelete(parseInt(`${componente.componente_id}`));
                        }}>
                        <Icon color="error">delete</Icon>
                    </IconButton>
                    )
                    : (
                        <IconButton
                            size={"small"}
                            onClick={() => {
                                handleReactive();
                            }}>
                            <Icon color="secondary">cached</Icon>
                        </IconButton>
                    )}
                </TableCell>
            </TableRow>
            {substitutos.map((substituto: ProjetoComponentesEdicao, index: number) => {

                return (
                    <TableRow key={`substituto-${substituto?.componente_id}-${index}`}>
                        <TableCell style={{ width: 112 }}>
                            <FontAwesomeIcon icon={faLevelUpAlt} color={orange[500]} style={{ transform: "rotate(90deg)" }} />&nbsp;{renderSituacao(substituto.situacao as SITUACAO_COMPONENTE)}
                        </TableCell>
                        <TableCell align="right">
                            {substituto?.componente_id}
                        </TableCell>
                        <TableCell>
                            {substituto?.modelo}
                        </TableCell>
                        <TableCell align="right">
                            - 
                        </TableCell>
                        <TableCell style={{ width: 130 }}>
                            <InputInteger
                                name={`quantidade-substituto-${substituto.componente_id}`}
                                margin="none"
                                value={substituto?.quantidade?.toString()}
                                label={null}
                                type={"number"}
                                maxLength={6}
                                onChangeValue={(name: string, value: any) => {
                                    const _componente = { ...substituto };
                                    const qtd = parseInt(value);
                                    if(qtd < 1){
                                        notifierStore.setNotifier({
                                            title: "Aviso",
                                            content: ["Quantidade informada não pode ser 0!"],
                                            onClose: () => {
                                                notifierStore.setOpen(false)
                                            },
                                            timeOut: 2_500,
                                        })
                                        notifierStore.setOpen(true);
                                        return;
                                    }
                                    _componente.quantidade = qtd;
                                    onChange(_componente, indexRow);

                                }}
                                onBlur={() => {

                                }}
                            />
                        </TableCell>
                        <TableCell style={{ width: 200 }} align={Formater.toAlign(TypeRecords.CURRENCY)} >
                            {Formater.toString(substituto?.valor_unitario || 0, TypeRecords.CURRENCY)}
                        </TableCell>
                        <TableCell style={{ width: 200 }}>
                            <InputDecimal
                                prefix={<><span>R$&nbsp;</span></>}
                                value={parseFloat(`${substituto?.valor}`)}
                                defaultValue={substituto.valor}
                                decimal={2}
                                maxLength={11}
                                label={null}

                                onChange={(event: any) => {
                                    const _componente = { ...substituto };
                                    const valor = parseFloat(event.target.value.toString().replace(/,/, "."));
                                    if(valor <= 0.0){
                                        notifierStore.setNotifier({
                                            title: "Aviso",
                                            content: ["Valor informada não pode ser 0!"],
                                            onClose: () => {
                                                notifierStore.setOpen(false)
                                            },
                                            timeOut: 2_500,
                                        })
                                        notifierStore.setOpen(true);
                                        return;
                                    }

                                    _componente.valor = Number(valor.toFixed(2));
                                    // setValorTotal(valor)
                                    onChange(_componente, indexRow, true)

                                }}
                                onBlur={() => {
                                    // onRecalc(componenteId);
                                }}
                            />
                        </TableCell>
                        <TableCell style={{ width: 66 }}></TableCell>
                        <TableCell style={{ width: 20 }}>
                            <IconButton
                                size={"small"}
                                onClick={() => {
                                    onDelete(parseInt(`${substituto.componente_id}`));
                                }}>
                                <Icon color="error">delete</Icon>
                            </IconButton>
                        </TableCell>
                    </TableRow>
                );
            })}
        </>
    );
}

export { RowComponente }